export const getProductCustomisation = state =>
  state.session.product.customisation;



// WEBPACK FOOTER //
// ./src/client/js/store/selectors/product.js